import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ToastCustomService } from '@shared/services/toast-custom.service';
import { HttpService } from 'src/app/core/http/http.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { IReportAdmin, REPORT_DATA,REPORT_DATA_ACCOUNT_PAYABLE } from '../../../models/report.model';
import _get from 'lodash/get';
import { UserService } from '@shared/services/user.service';
import { IUser } from '@shared/models/login.model';
import { ACCOUNT_PAYABLE_ROLE_ID } from '@shared/globals/app-constants';

@Component({
  selector: 'app-download-reports',
  templateUrl: './download-reports.component.html',
  styleUrls: ['./download-reports.component.scss']
})
export class DownloadReportsComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public reports: IReportAdmin[] = REPORT_DATA;
  public reportsAccountPayable: IReportAdmin[] = REPORT_DATA_ACCOUNT_PAYABLE;
  public reportForm: FormGroup;
  public isRequesting = false;
  public user: IUser;

  constructor(
    private service: HttpService,
    private dialogRef: MatDialogRef<DownloadReportsComponent>,
    private fb: FormBuilder,
    private ts: ToastCustomService,
    private dp: DatePipe,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.createForm();
    this.user = this.userService.userInfo;
    this.accountPayableReport();
    
  }

  private createForm(): void {
    this.reportForm = this.fb.group({
      report_config: [null, Validators.required],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required]
    });
  }

  public generateReport(): void {
    this.isRequesting = true;
    const startDate = this.dp.transform(
      this.reportForm.controls.start_date.value,
      'yyyy-MM-dd'
    );
    const endDate = this.dp.transform(
      this.reportForm.controls.end_date.value,
      'yyyy-MM-dd'
    );
    const reportConfig: IReportAdmin = this.reportForm.controls.report_config
      .value;
    const payload = {
      dates: {
        start: startDate,
        end: endDate
      }
    };

    if (reportConfig.name === 'Damaged Orders')
      payload['order_status'] = 'damage';

    this.subs.add(
      this.service
        .get(`report/${reportConfig.type}/file`, {
          filters: JSON.stringify(payload)
        })
        .subscribe(
          (res: any) => {
            this.isRequesting = false;
            const base64 = _get(res, 'base64', '');
            const name = _get(res, 'name', '');
            if (base64 && name) {
              this.downloadBase64(base64, name);
              this.dialogRef.close(true);
            } else {
              this.ts.show(
                'warning',
                'There is no information',
                'No information to download in the dates selected'
              );
            }
          },
          error => {
            this.isRequesting = false;
          }
        )
    );
  }

  private downloadBase64(base64, name) {
    const a = document.createElement('a');
    a.href = `data:application/pdf;base64,${base64}`;
    a.download = name;
    a.click();
  }

  public accountPayableReport(): void {
    if(this.user.role.id === ACCOUNT_PAYABLE_ROLE_ID) {
      this.reportForm.get('report_config').setValue(this.reportsAccountPayable[0]);
    } 
}
  }
